/**
 * Central tuning constants for the TWCG-2055 "Flag to Share" experiment.
 *
 * Kept in one module so the criteria evaluator, the inactivity timer, and tests
 * all reference the same source of truth.
 */

/**
 * How long editing must stay idle after the criteria are met before the nudge
 * fires. The timer resets on every new progress signal.
 */
export const INACTIVITY_MS = 2_500;

/** Live Docs: words written (delta) required to meet the share criteria. */
export const LIVE_DOC_WORDS = 100;

/**
 * Database: criteria met when more than `DB_ROWS` rows are created AND at least one
 * cell is filled, OR when more than `DB_CELLS` cells are filled. Values are
 * exclusive thresholds (i.e. `> DB_ROWS` / `> DB_CELLS`).
 */
export const DB_ROWS = 3;
export const DB_CELLS = 3;

/** Whiteboard: objects added required to meet the share criteria. */
export const WHITEBOARD_OBJECTS = 3;
